import React from "react";
import { Box, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";
import { MiniDrawer } from "./drawers/MiniDrawer";

const MiniDrawerComponent = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Mini Variant Drawer
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          background
          height={"300px"}
          language="js"
          value={
            'import * as React from "react";\n' +
            'import { styled, useTheme } from "@mui/material/styles";\n' +
            'import Box from "@mui/material/Box";\n' +
            'import MuiDrawer from "@mui/material/Drawer";\n' +
            'import MuiAppBar from "@mui/material/AppBar";\n' +
            'import Toolbar from "@mui/material/Toolbar";\n' +
            'import List from "@mui/material/List";\n' +
            'import CssBaseline from "@mui/material/CssBaseline";\n' +
            'import Typography from "@mui/material/Typography";\n' +
            'import Divider from "@mui/material/Divider";\n' +
            'import IconButton from "@mui/material/IconButton";\n' +
            'import MenuIcon from "@mui/icons-material/Menu";\n' +
            'import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";\n' +
            'import ChevronRightIcon from "@mui/icons-material/ChevronRight";\n' +
            'import ListItem from "@mui/material/ListItem";\n' +
            'import ListItemButton from "@mui/material/ListItemButton";\n' +
            'import ListItemIcon from "@mui/material/ListItemIcon";\n' +
            'import ListItemText from "@mui/material/ListItemText";\n' +
            'import InboxIcon from "@mui/icons-material/MoveToInbox";\n' +
            'import MailIcon from "@mui/icons-material/Mail";\n' +
            "\n" +
            "const drawerWidth = 240;\n" +
            "\n" +
            "const openedMixin = (theme) => ({\n" +
            "  width: drawerWidth,\n" +
            '  transition: theme.transitions.create("width", {\n' +
            "    easing: theme.transitions.easing.sharp,\n" +
            "    duration: theme.transitions.duration.enteringScreen,\n" +
            "  }),\n" +
            '  overflowX: "hidden",\n' +
            "});\n" +
            "\n" +
            "const closedMixin = (theme) => ({\n" +
            '  transition: theme.transitions.create("width", {\n' +
            "    easing: theme.transitions.easing.sharp,\n" +
            "    duration: theme.transitions.duration.leavingScreen,\n" +
            "  }),\n" +
            '  overflowX: "hidden",\n' +
            "  width: `calc(${theme.spacing(7)} + 1px)`,\n" +
            '  [theme.breakpoints.up("sm")]: {\n' +
            "    width: `calc(${theme.spacing(8)} + 1px)`,\n" +
            "  },\n" +
            "});\n" +
            "\n" +
            'const DrawerHeader = styled("div")(({ theme }) => ({\n' +
            '  display: "flex",\n' +
            '  alignItems: "center",\n' +
            '  justifyContent: "flex-end",\n' +
            "  padding: theme.spacing(0, 1),\n" +
            "  // necessary for content to be below app bar\n" +
            "  ...theme.mixins.toolbar,\n" +
            "}));\n" +
            "\n" +
            "const AppBar = styled(MuiAppBar, {\n" +
            '  shouldForwardProp: (prop) => prop !== "open",\n' +
            "})(({ theme, open }) => ({\n" +
            "  //zIndex: theme.zIndex.drawer + 1,\n" +
            '  transition: theme.transitions.create(["width", "margin"], {\n' +
            "    easing: theme.transitions.easing.sharp,\n" +
            "    duration: theme.transitions.duration.leavingScreen,\n" +
            "  }),\n" +
            "  ...(open && {\n" +
            "    marginLeft: drawerWidth,\n" +
            "    width: `calc(100% - ${drawerWidth}px)`,\n" +
            '    transition: theme.transitions.create(["width", "margin"], {\n' +
            "      easing: theme.transitions.easing.sharp,\n" +
            "      duration: theme.transitions.duration.enteringScreen,\n" +
            "    }),\n" +
            "  }),\n" +
            "}));\n" +
            "\n" +
            "const Drawer = styled(MuiDrawer, {\n" +
            '  shouldForwardProp: (prop) => prop !== "open",\n' +
            "})(({ theme, open }) => ({\n" +
            "  width: drawerWidth,\n" +
            "  flexShrink: 0,\n" +
            '  whiteSpace: "nowrap",\n' +
            '  boxSizing: "border-box",\n' +
            "  ...(open && {\n" +
            "    ...openedMixin(theme),\n" +
            '    "& .MuiDrawer-paper": openedMixin(theme),\n' +
            "  }),\n" +
            "  ...(!open && {\n" +
            "    ...closedMixin(theme),\n" +
            '    "& .MuiDrawer-paper": closedMixin(theme),\n' +
            "  }),\n" +
            "}));\n" +
            "\n" +
            "export const MiniDrawer = () => {\n" +
            "  const theme = useTheme();\n" +
            "  const [open, setOpen] = React.useState(false);\n" +
            "\n" +
            "  const handleDrawerOpen = () => {\n" +
            "    setOpen(true);\n" +
            "  };\n" +
            "\n" +
            "  const handleDrawerClose = () => {\n" +
            "    setOpen(false);\n" +
            "  };\n" +
            "\n" +
            "  return (\n" +
            '    <Box sx={{ display: "flex", position: "relative" }}>\n' +
            "      <CssBaseline />\n" +
            '      <AppBar position="absolute" open={open}>\n' +
            "        <Toolbar>\n" +
            "          <IconButton\n" +
            '            color="inherit"\n' +
            '            aria-label="open drawer"\n' +
            "            onClick={handleDrawerOpen}\n" +
            '            edge="start"\n' +
            "            sx={{\n" +
            "              marginRight: 5,\n" +
            '              ...(open && { display: "none" }),\n' +
            "            }}\n" +
            "          >\n" +
            "            <MenuIcon />\n" +
            "          </IconButton>\n" +
            '          <Typography variant="h6" noWrap component="div">\n' +
            "            Mini variant drawer\n" +
            "          </Typography>\n" +
            "        </Toolbar>\n" +
            "      </AppBar>\n" +
            '      <Drawer variant="permanent" open={open} sx={{ position: "relative" }}>\n' +
            "        <DrawerHeader>\n" +
            "          <IconButton onClick={handleDrawerClose}>\n" +
            '            {theme.direction === "rtl" ? (\n' +
            "              <ChevronRightIcon />\n" +
            "            ) : (\n" +
            "              <ChevronLeftIcon />\n" +
            "            )}\n" +
            "          </IconButton>\n" +
            "        </DrawerHeader>\n" +
            "        <Divider />\n" +
            "        <List>\n" +
            '          {["Inbox", "Starred", "Send email", "Drafts"].map((text, index) => (\n' +
            '            <ListItem key={text} disablePadding sx={{ display: "block" }}>\n' +
            "              <ListItemButton\n" +
            "                sx={{\n" +
            "                  minHeight: 48,\n" +
            '                  justifyContent: open ? "initial" : "center",\n' +
            "                  px: 2.5,\n" +
            "                }}\n" +
            "              >\n" +
            "                <ListItemIcon\n" +
            "                  sx={{\n" +
            "                    minWidth: 0,\n" +
            '                    mr: open ? 3 : "auto",\n' +
            '                    justifyContent: "center",\n' +
            "                  }}\n" +
            "                >\n" +
            "                  {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}\n" +
            "                </ListItemIcon>\n" +
            "                <ListItemText primary={text} sx={{ opacity: open ? 1 : 0 }} />\n" +
            "              </ListItemButton>\n" +
            "            </ListItem>\n" +
            "          ))}\n" +
            "        </List>\n" +
            "        <Divider />\n" +
            "        <List>\n" +
            '          {["All mail", "Trash", "Spam"].map((text, index) => (\n' +
            '            <ListItem key={text} disablePadding sx={{ display: "block" }}>\n' +
            "              <ListItemButton\n" +
            "                sx={{\n" +
            "                  minHeight: 48,\n" +
            '                  justifyContent: open ? "initial" : "center",\n' +
            "                  px: 2.5,\n" +
            "                }}\n" +
            "              >\n" +
            "                <ListItemIcon\n" +
            "                  sx={{\n" +
            "                    minWidth: 0,\n" +
            '                    mr: open ? 3 : "auto",\n' +
            '                    justifyContent: "center",\n' +
            "                  }}\n" +
            "                >\n" +
            "                  {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}\n" +
            "                </ListItemIcon>\n" +
            "                <ListItemText primary={text} sx={{ opacity: open ? 1 : 0 }} />\n" +
            "              </ListItemButton>\n" +
            "            </ListItem>\n" +
            "          ))}\n" +
            "        </List>\n" +
            "      </Drawer>\n" +
            '      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>\n' +
            "        <DrawerHeader />\n" +
            "        <Typography paragraph>\n" +
            "          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do\n" +
            "          eiusmod tempor incididunt ut labore et dolore magna aliqua. Rhoncus\n" +
            "          dolor purus non enim praesent elementum facilisis leo vel. Risus at\n" +
            "          ultrices mi tempus imperdiet. Semper risus in hendrerit gravida rutrum\n" +
            "          quisque non tellus. Convallis convallis tellus id interdum velit\n" +
            "          laoreet id donec ultrices. Odio morbi quis commodo odio aenean sed\n" +
            "          adipiscing. Amet nisl suscipit adipiscing bibendum est ultricies\n" +
            "          integer quis. Cursus euismod quis viverra nibh cras. Metus vulputate\n" +
            "          eu scelerisque felis imperdiet proin fermentum leo. Mauris commodo\n" +
            "          quis imperdiet massa tincidunt. Cras tincidunt lobortis feugiat\n" +
            "          vivamus at augue. At augue eget arcu dictum varius duis at consectetur\n" +
            "          lorem. Velit sed ullamcorper morbi tincidunt. Lorem donec massa sapien\n" +
            "          faucibus et molestie ac.\n" +
            "        </Typography>\n" +
            "      </Box>\n" +
            "    </Box>\n" +
            "  );\n" +
            "};\n"
          }
        >
          <MiniDrawer />
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default MiniDrawerComponent;
